export const GET_STATE='get_state_list/'
export const GET_CITY='get_city_list/'